var _excluded = ["icon", "href", "active", "disabled", "children"];

var _templateObject;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { forwardRef } from 'react';
import { Item as MenuItemRoot } from '@radix-ui/react-dropdown-menu';
import { oneOfType, func, node, string, bool } from 'prop-types';
import styled from 'styled-components';
var StyledMenuItem = styled.li(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  ", "\n"])), function (_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      menu = _ref.theme.yoga.components.menu;
  return "\n    margin-right: auto;\n    padding: " + menu.padding.vertical + "px " + menu.padding.horizontal + "px;\n\n    width: 100%;\n    cursor: pointer;\n    text-decoration: none;\n    color: " + menu.text["default"].color + ";\n\n    " + (active ? "\n      font-weight: " + menu.font.weight + ";\n      color: " + menu.text.active.color + "\n      " : '') + "\n\n    " + (disabled ? "\n        color: " + menu.text.disabled.color + ";\n        pointer-events: none;\n\n        svg {\n          fill: " + menu.text.disabled.color + ";\n          opacity: 0.5;\n        }\n\n        cursor: not-allowed;\n    " : '') + "\n\n    svg {\n      margin-right: " + menu.margin["default"] + "px;\n      fill: " + menu.icon.disabled + ";\n    }\n\n    &:focus {\n      outline: none;\n      background: " + menu.backgroundColor.disabled + ";\n    }\n\n    &:hover {\n      background: " + menu.backgroundColor.disabled + ";\n    }\n\n    &:first-child {\n      margin-top: " + menu.margin.xxsmall + "px;\n    }\n\n    &:last-child {\n      margin-bottom: " + menu.margin.xxsmall + "px;\n    }\n  ";
});
var MenuItem = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var Icon = _ref2.icon,
      href = _ref2.href,
      active = _ref2.active,
      disabled = _ref2.disabled,
      children = _ref2.children,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var finalProps = _extends({}, rest);

  if (href) {
    finalProps.as = 'a';
    finalProps.href = href;
  }

  return /*#__PURE__*/React.createElement(MenuItemRoot, {
    disabled: disabled,
    asChild: true
  }, /*#__PURE__*/React.createElement(StyledMenuItem, _extends({
    active: active,
    disabled: disabled,
    ref: ref
  }, finalProps), Icon && /*#__PURE__*/React.createElement(Icon, {
    width: 20,
    height: 20
  }), children));
});
MenuItem.propTypes = {
  /** The icon of menu item */
  icon: oneOfType([node, func]),
  children: node.isRequired,
  href: string,
  disabled: bool,
  active: bool
};
MenuItem.defaultProps = {
  icon: undefined,
  href: undefined,
  disabled: false,
  active: false
};
MenuItem.displayName = 'Menu.Item';
export default MenuItem;